export enum GameView {
  multiChoice = 0,
  pictureRound = 1,
  chooseTen = 2,
  puzMatching = 3,
  twoColumn = 4,
}
